import { IconButton, Input } from "@aurem/ui";
import { SearchIcon, XIcon } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { useGlobalSearchContext } from "../context";

export const SearchHeader = () => {
  const { t } = useI18n();
  const { query, setQuery, onDismiss } = useGlobalSearchContext();

  return (
    <header className="sticky top-0 h-12 rounded-t-2xl border-b border-neutral-500/10 z-10">
      <Input
        className="pe-10 rounded-b-none border-none [&]:!outline-none h-full"
        value={query}
        onChange={setQuery}
        placeholder={t("apps.admin.common.search")}
        autoFocus
        autoComplete="off"
        startAccessory={
          <div className="w-8 h-8 flex items-center justify-center">
            <SearchIcon size={18} className="rtl:-scale-x-100" />
          </div>
        }
      />
      <IconButton
        variant="ghost"
        color="neutral"
        size="sm"
        className="absolute top-2 end-2"
        aria-label={t("apps.admin.common.dismiss")}
        onClick={onDismiss}
      >
        <XIcon />
      </IconButton>
    </header>
  );
};
